import { gql } from '@apollo/client';

import { ActivePracticeSession } from '../../types';
import { ActivePracticeSessionFragment } from '../fragments';

export interface GetNextExerciseInPracticeSessionQueryVariables {
  courseId: string;
  practiceSessionId: string;
}

export interface GetNextExerciseInPracticeSessionQueryResult {
  activePracticeSession: ActivePracticeSession;
}

export const getNextExerciseInPracticeSessionQuery = gql`
  query GetNextExerciseInPracticeSession($courseId: String!, $practiceSessionId: String!) {
    activePracticeSession(courseId: $courseId, practiceSessionId: $practiceSessionId)
      @rest(type: "ActivePracticeSession", path: "courses/{args.courseId}/practice/{args.practiceSessionId}/next-exercise") {
      ...ActivePracticeSession
    }
  }
  ${ActivePracticeSessionFragment}
`;
